import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { accordionSx, summarySx, detailsSx, sectionDisabledSx } from "./SectionAccordion.styles";

export function SectionAccordion({
        title,
        loading,
        defaultExpanded = false,
        disabled = false,
        children
    }){
        return (
            <Accordion disableGutters defaultExpanded={defaultExpanded} sx={accordionSx} >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}  sx={summarySx}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                <Typography fontWeight={600}>{title}</Typography>
                {loading && <CircularProgress size={22} />}
                </Stack>
            </AccordionSummary>

            <AccordionDetails sx={detailsSx}>
                <Box sx={sectionDisabledSx(disabled)} >
                    {children}
                </Box>
            </AccordionDetails>
        </Accordion>
        )
    }